// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipMarkerContainer {
  font-size: 13px;
  z-index: 1;
  position: absolute;
  pointer-events: all;
}
.tooltipMarkerContainer .tooltip {
  pointer-events: initial;
  position: absolute;
  width: 150px;
  box-shadow: 0px 9px 8px -8px rgba(34, 34, 34, 0.4);
  color: var(--motes-black);
}
.tooltipMarkerContainer .tooltip .item {
  padding: var(--motes-padding);
  box-sizing: border-box;
  height: 40px;
  background-color: var(--motes-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
.tooltipMarkerContainer .tooltip .item:last-child {
  border-radius: 0 0 var(--border-radius) var(--border-radius);
}
.tooltipMarkerContainer .tooltip .item:not(:last-child) {
  border-bottom: 1px var(--motes-lighter-gray) solid;
}
.tooltipMarkerContainer .tooltip .item.bold {
  font-weight: bold;
}
.tooltipMarkerContainer .tooltip .item.red {
  color: var(--motes-light-red);
}
.tooltipMarkerContainer .tooltip .item:hover {
  transition: 0.2s;
  background-color: var(--motes-off-white);
}
.tooltipMarkerContainer .tooltip .item:first-child {
  border-radius: var(--border-radius) var(--border-radius) 0 0;
}
.tooltipMarkerContainer .tooltip .item:first-child::after {
  content: "";
  position: absolute;
  border: 6px solid black;
  border-color: transparent transparent #ffffff #ffffff;
  transform: rotate(224deg);
  box-shadow: -3px 1px 4px -2px rgba(34, 34, 34, 0.35);
  top: 16px;
  right: -6px;
}
.tooltipMarkerContainer .tooltip .item:first-child:hover::after {
  transition: 0.2s;
  border-color: transparent transparent #eeeeee #eeeeee;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/editor-page/components/waypoint-tooltip/waypoint-tooltip.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;EACI,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,kDAAA;EACA,yBAAA;AACR;AACQ;EACI,6BAAA;EACA,sBAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACZ;AACY;EACI,4DAAA;AAChB;AAEY;EACI,kDAAA;AAAhB;AAGY;EACI,iBAAA;AADhB;AAIY;EACI,6BAAA;AAFhB;AAKY;EACI,gBAAA;EACA,wCAAA;AAHhB;AAMY;EACI,4DAAA;AAJhB;AAOgB;EACI,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,qDAAA;EACA,yBAAA;EACA,oDAAA;EACA,SAAA;EACA,WAAA;AALpB;AAQgB;EACI,gBAAA;EACA,qDAAA;AANpB","sourcesContent":[".tooltipMarkerContainer {\n    font-size: 13px;\n    z-index: 1;\n    position: absolute;\n    pointer-events: all;\n\n    .tooltip {\n        pointer-events: initial;\n        position: absolute;\n        width: 150px;\n        box-shadow: 0px 9px 8px -8px rgba(34, 34, 34, 0.4);\n        color: var(--motes-black);\n        \n        .item {\n            padding: var(--motes-padding);\n            box-sizing: border-box;\n            height: 40px;\n            background-color: var(--motes-white);\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            cursor: pointer;\n\n            &:last-child {\n                border-radius: 0 0 var(--border-radius) var(--border-radius);\n            }\n    \n            &:not(:last-child) {\n                border-bottom: 1px var(--motes-lighter-gray) solid;\n            }\n\n            &.bold {\n                font-weight: bold;\n            }\n\n            &.red {\n                color: var(--motes-light-red);\n            }\n\n            &:hover {\n                transition: 0.2s;\n                background-color: var(--motes-off-white);\n            }\n\n            &:first-child {\n                border-radius: var(--border-radius) var(--border-radius) 0 0;\n\n                // Triangle on the tooltip side\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    border: 6px solid black;\n                    border-color: transparent transparent #ffffff #ffffff;\n                    transform: rotate(224deg);\n                    box-shadow: -3px 1px 4px -2px rgb(34 34 34 / 35%);\n                    top: 16px;\n                    right: -6px;\n                }\n\n                &:hover::after {\n                    transition: 0.2s;\n                    border-color: transparent transparent #eeeeee #eeeeee;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
